import React, { useState } from "react";
import { Icon } from "antd";
export const ChatInviteAccept = ({ handleAcceptInvite, users }) => {
  return (
    <div className="user-chat-list">
      {users.map((user) => (
        <div
          key={user.id}
          className={`user-item-invite`}
        >
          <div className="user-item-invited-inner">
            {user.image ? (
              <div style={{ borderRadius: "50%" }}>
                <img
                  src={user.image}
                  height={"48px"}
                  width={"48px"}
                  alt={"new"}
                  style={{ borderRadius: "1rem" }}
                />
              </div>
            ) : (
              <div className="contact-chat-logo">
                {user.name
                  ? user.name
                      .split(" ")
                      .map((part) => part[0])
                      .join("")
                  : "N/A"}
              </div>
            )}{" "}
            <span className="contact-chat-name">{user.name}</span>
          </div>
          {/*<Icon type="close-circle" style={{fontSize:"20px", color:"green",fontWeight:"700"}} theme="filled" 
          onClick={() => {
            handleAcceptInvite(user);
          }} 
          /> */}
          <button
            className="chat-accept-invite-button"
            onClick={() => {
              handleAcceptInvite(user);
            }}
          >
            Accept
          </button> 
        {/*  <Icon
            type="check-circle"
            style={{ fontSize: "20px", color: "#09A84D", fontWeight: "700" }}
            theme="filled"
            onClick={() => {
              handleAcceptInvite(user);
            }}
          /> */}
        </div>
      ))}
    </div>
  );
};
